import Api from "./Api";

export default {
  updateData(payload) {
    return Api({ hasFile: payload.hasFile }).post(
      "update-data",
      payload.formData
    );
  },
  getFiles(company_id) {
    return Api().get(`/files/${company_id}`);
  },
  deleteFile(company_id, file_id) {
    return Api().delete(`/files/${company_id}/${file_id}`);
  }
};
